import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CheckoutMiddleware from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';
import CartMiddleware from 'yoda-checkout-components/lib/middlewares/CartAnalyticsMiddleware';

const rootMiddleware = [CommonMiddleware, CheckoutMiddleware, CartMiddleware];

export default rootMiddleware;
